const MODAL = 'data-modal'
const MODAL_CLOSE = 'data-modal-close'
const MODAL_CONTENT = 'data-modal-content'
const MODAL_TRIGGER = 'data-modal-trigger'
const MODAL_DATA = 'data-modal-data'
const MODAL_CLASS = 'data-modal-class'

const $modal = document.querySelector(`[${MODAL}]`)
const $modalContent = document.querySelector(`[${MODAL_CONTENT}]`)
const $modalClose = document.querySelector(`[${MODAL_CLOSE}]`)

/**
 * Cookies methods
 */
 function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}
function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function init(){
  const $modalTriggers = document.querySelectorAll(`[${MODAL_TRIGGER}]`)

  // if ($modalTriggers.length === 0) return

  // bind modal closer
  $modalClose.addEventListener('click', (e) => {
    hideModal();
  });

  jQuery(document).on('click', '[data-modal-webform-close]', function(e) {
    if (e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.modalWebformClose) {
      hideWebformModal(e.currentTarget.dataset.modalWebformClose);
    }
  });

  const accountCloseButton = document.getElementById('accountModalClose')
  const accountModal = document.getElementById('accountModal');
  if (accountCloseButton) {
    accountCloseButton.addEventListener('click', (e) => {
      accountModal.style.display = 'none';
    });
  }

  // init modal triggers
  initModals($modalTriggers)
  initAccountModal()

  // display modal on #acheter-le-livre present on load
  if (window.location.hash === '#acheter-le-livre') {
    openModal('book-header-buy-book');
  }

  // show modal magazine every seven days with a maximum of 3 days
  const modalMagazineCookie = getCookie('modal-subscribe-magazine');
  const modalMagazineCookieCount = getCookie('modal-subscribe-magazine-count');
  const modalMagazineCookieNbOpened = modalMagazineCookieCount == null ? 0 : parseInt(modalMagazineCookieCount, 10);
  if (modalMagazineCookie == null && modalMagazineCookieNbOpened < 3) {
    setTimeout(function () {
      setCookie('modal-subscribe-magazine-count', modalMagazineCookieNbOpened+1, 365);
      setCookie('modal-subscribe-magazine', true, 7);
      openWebformModal('subscribeMagazineModal');
    }, 10000);
  }
}

function initModals($triggers) {
  $triggers.forEach($trigger => {
    const modalContentContainer = $trigger.getAttribute(MODAL_TRIGGER)
    const $modalData = document.querySelector(`[${MODAL_DATA}=${modalContentContainer}]`)
    const modalClass = $modalData.getAttribute(MODAL_CLASS)
    $trigger.addEventListener('click', (e) => {
      e.preventDefault();
      $modal.style.display = 'block';
      if (modalClass) {
        $modal.classList.add(modalClass)
      }
      $modalContent.innerHTML = $modalData.innerHTML
      $modalData.remove()
      return false;
    })
  })
}

/**
 * Populate and open modal from external JS
 */
function openModal(modalId) {
  const $modalData = document.querySelector(`[${MODAL_DATA}=${modalId}]`)
  const modalClass = $modalData.getAttribute(MODAL_CLASS);
  $modal.style.display = 'block';
  if (modalClass) {
    $modal.classList.add(modalClass)
  }
  $modalContent.innerHTML = $modalData.innerHTML
  $modalData.remove()
}

/**
 * Show already populated modal
 */
function openWebformModal(modalId) {
  const $modal = document.querySelector(`[data-modal-webform=${modalId}]`)
  $modal.style.display = 'block';
}

/**
 * Hide already populated modal
 */
function hideWebformModal(modalId) {
  const $modal = document.querySelector(`[data-modal-webform=${modalId}]`)
  $modal.style.display = 'none';
}

function initAccountModal() {
  const $modal = jQuery('#accountModal');
  jQuery(document).on('click', '.login-modal-trigger', (e) => {
    e.preventDefault();
    let action = jQuery(e.currentTarget).attr('data-on-login');
    if (action) $modal.find('form').attr('data-on-login', action)
    $modal.show();
    return false;
  })
}

function hideModal() {
  $modalContent.innerHTML = '';
  $modal.style.display = 'none';
}

export default { init }
